import { useState, useCallback, useEffect } from 'react';

import { toast } from "react-toastify";

let logoutTimer;

export const useAuth = () => {
  const [token, setToken] = useState(false);
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [userId, setUserId] = useState(false);

  // adding registered state
  const [isRegistered, setIsRegistered] = useState(false);

  const [userName, setUserName] = useState('');

  const login = useCallback((uid, token, userName, expirationDate) => {
    setToken(token);
    setUserId(uid);
    setUserName(userName);

    const tokenExpirationDate =
      expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60);
    setTokenExpirationDate(tokenExpirationDate);
    localStorage.setItem(
      'userData',
      JSON.stringify({
        userId: uid,
        userName: userName,
        token: token,
        expiration: tokenExpirationDate.toISOString()
      })
    );

   
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setTokenExpirationDate(null);
    setUserId(null);

    setIsRegistered(false);

    localStorage.removeItem('userData');

    toast.success("Logged out successfully");
  }, []);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData'));
    if (
      storedData &&
      storedData.token &&
      new Date(storedData.expiration) > new Date()
    ) {
      login(storedData.userId, storedData.token, storedData.userName, new Date(storedData.expiration));
    }
  }, [login]);

  return { token, login, logout, userId, userName, isRegistered, setIsRegistered };
};